import { Icon } from '../../shared';
import styles from './ChatNavigation.module.css';

export type ChatView = 'chat' | 'assistants' | 'history';

export interface ChatNavigationProps {
  currentView: ChatView;
  onViewChange: (view: ChatView) => void;
  variant?: 'default' | 'compact' | 'floating';
  showAssistants?: boolean;
  showHistory?: boolean;
  isOpen?: boolean;
  onToggle?: () => void;
  className?: string;
}

export function ChatNavigation({
  currentView,
  onViewChange,
  variant = 'default',
  showAssistants = true,
  showHistory = true,
  isOpen = true,
  onToggle,
  className = '',
}: ChatNavigationProps) {
  const handleViewChange = (view: ChatView) => {
    onViewChange(view);
    if (!isOpen && onToggle) {
      onToggle();
    }
  };

  const isFloating = variant === 'floating';

  return (
    <nav className={`${styles.nav} ${styles[variant]} ${isOpen ? styles.navOpen : ''} ${className}`}>
      {!isFloating && (
        <div className={styles.logoTop}>
          <Icon name="devxgpt-logo" size={variant === 'compact' ? 32 : 40} aria-hidden={false} />
        </div>
      )}

      <div className={styles.navItems}>
        <button
          className={`${styles.navItem} ${currentView === 'chat' ? styles.active : ''}`}
          onClick={() => handleViewChange('chat')}
          aria-label="Chat"
          title="Chat"
        >
          <Icon name="chat" size={isFloating ? 20 : 24} />
        </button>

        {showAssistants && (
          <button
            className={`${styles.navItem} ${currentView === 'assistants' ? styles.active : ''}`}
            onClick={() => handleViewChange('assistants')}
            aria-label="All Assistants"
            title="All Assistants"
          >
            <Icon name="assistants" size={isFloating ? 20 : 24} />
          </button>
        )}

        {showHistory && (
          <button
            className={`${styles.navItem} ${currentView === 'history' ? styles.active : ''}`}
            onClick={() => handleViewChange('history')}
            aria-label="Chat History"
            title="Chat History"
          >
            <Icon name="history" size={isFloating ? 20 : 24} />
          </button>
        )}
      </div>

      {!isFloating && (
        <div className={styles.logoBottom}>
          <div className={styles.logoCircle}>
            <Icon name="pepsi-logo-new" size={variant === 'compact' ? 30 : 40} aria-hidden={false} />
          </div>
        </div>
      )}
    </nav>
  );
}
